import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { Drawer } from "@material-ui/core";
import "./sidebar.css";
import logo from "../../assets/images/logo.png";
import SidebarItem from "./SidebarItem";

const drawerWidth = 230;

const company_routes = [
  {
    display_name: "Dashboard",
    route: "/admin/company-dashboard",
    icon: "bx bxs-dashboard",
  },
  {
    display_name: "My Profile",
    route: "/admin/profile",
    icon: "bx bx-user-circle",
  },
];

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: (props) => (props.open ? drawerWidth : 0),
    flexShrink: 0,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
  },
  drawerPaper: {
    width: drawerWidth,
  },
  borderR: {
    borderRight: "none",
  },
}));

const Sidebar = (props) => {
  const { open, variant, onClose } = props;
  const classes = useStyles(props);

  const sidebar_items = company_routes;

  const activeItem = sidebar_items.findIndex(
    (item) => item.route === props.location.pathname
  );

  const handleLinkClick = () => {
    if (variant === "temporary") {
      onClose();
    }
  };

  return (
    <Drawer
      className={classes.drawer}
      variant={variant || "persistent"}
      anchor="left"
      open={open}
      onClose={onClose}
      classes={{
        paperAnchorDockedLeft: classes.borderR,
        paper: classes.drawerPaper,
      }}
    >
      <div className="sidebar">
        <div className="sidebar__logo">
          <img src={logo} alt="company logo" />
        </div>
        {sidebar_items.map((item, index) => (
          <Link to={item.route} key={index} onClick={handleLinkClick}>
            <SidebarItem
              title={item.display_name}
              icon={item.icon}
              key={index}
              active={index === activeItem}
            />
          </Link>
        ))}
      </div>
    </Drawer>
  );
};

export default Sidebar;
